module.exports = __webpack_public_path__ + "img/14.20b6ff8c.jpg";